import { Link } from "react-router-dom";
import logo from "../../assets/img/fsl_logo.png";

type Props = {
  width?: number;
  text?: "lg" | "xl" | "2xl";
};

export default function Logo({ width, text }: Props) {
  const imgWidth = width || 130;
  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <section style={{ display: "flex", alignItems: "center" }}>
        <img src={logo} alt="FSL logo" width={imgWidth} style={{ height: "auto" }} />
      </section>
    </Link>
  );
}
